//@ts-nocheck
/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { FeatureFlag } from "../FeatureFlag";

export const EnablePaymentReceipts: FeatureFlag = {"Id":"EnablePaymentReceipts","Label":"Support payments receipt on pdfs","Impact":"Shows a sections with payment information on generated PDF (unless it is disabled in that Generated PDF configuration)","Mode":1,"ActiveOn":null,"ActiveUntil":null,"GlobalEnabled":false,"TenantEnabled":null,"UserEnabled":null,"Scope":7};
